import { Link } from 'react-router-dom';
import { useAssessmentTimes, type AssessmentTimes } from '../api/use-assessment-times.js';
import { WaitNote } from '../components/wait-note.js';

/**
 * The team's dedicated assessment times (032; Q6, board B2): a LIST of days and
 * times, not the date search. Reached from the Home notice; each hour opens the
 * hour screen, whose chevron comes back here.
 */
export function AssessmentTimesRoute() {
  const state = useAssessmentTimes();
  const teams = state.status === 'ready' ? state.times.teams.map((team) => team.name).join(', ') : '';

  return (
    <>
      <div className="page-head">
        <Link className="back" to="/" aria-label="Back to Home">
          ‹
        </Link>
        <div>
          <h2>Assessment times</h2>
          {teams ? <span className="detail">{teams}</span> : null}
        </div>
      </div>

      {state.status === 'loading' ? <WaitNote className="empty">Checking…</WaitNote> : null}
      {state.status === 'failed' ? <p className="empty">{state.message}</p> : null}
      {state.status === 'ready' && state.times.slots.length === 0 ? <p className="empty">No assessment times.</p> : null}

      {state.status === 'ready'
        ? byDay(state.times.slots).map(([day, slots]) => (
            <div key={day} className="day-group">
              <span className="section-label">{day}</span>
              {slots.map((slot) => (
                <Link key={slot.slot_id} className="hour-row" to={`/booking/${slot.slot_id}?from=assessments`}>
                  <span className="hour-row-text">
                    <span className="name">{startTime(slot.slot_start)}</span>
                    <span className="detail">
                      {slot.facility_name} · {slot.resource_name}
                    </span>
                  </span>
                  <span className="chevron" aria-hidden="true">
                    ›
                  </span>
                </Link>
              ))}
            </div>
          ))
        : null}
    </>
  );
}

type Slot = AssessmentTimes['slots'][number];

function startTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-GB', { hour: 'numeric', minute: '2-digit' });
}

function byDay(slots: Slot[]): [string, Slot[]][] {
  const days = new Map<string, Slot[]>();
  for (const slot of slots) {
    const day = new Date(slot.slot_start).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
    days.set(day, [...(days.get(day) ?? []), slot]);
  }
  return [...days.entries()];
}
